import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../ErrorPage/ErrorPage.module.scss';
import { ErrorType } from '../../services/ErrorBoundaryService';

export const ErrorPage = (props: { errorType: ErrorType }) => {
  const { errorType } = props;

  const { t } = useTranslation();
  const getErrorMessage = () => {
    switch (errorType) {
      case ErrorType.SystemNotFound:
        return t('WeCantSeemToFind...');

      case ErrorType.ApiServiceError:
        return t('ApiServiceUnavailable');

      case ErrorType.ShortcutNotFound:
        return t('WeCantSeemToFind...');

      default:
        return 'Something went wrong while processing your request';
    }
  };

  return (
    <div className={styles['page-wrapper']}>
      <div className={styles['left-container']}>
        <div className={styles['error-message-wrapper']}>
          <div className={styles['error-message-div-1']}>
            <h1>{t('Oops')}</h1>
          </div>
          <div className={styles['error-message-div-2']}>
            <p>{getErrorMessage()}</p>
          </div>
          {(props.errorType === ErrorType.SystemNotFound || props.errorType === ErrorType.ShortcutNotFound) && (
            <div className={styles['error-message-div-3']}>
              <p>{t('StatusCode404')}</p>
            </div>
          )}
          <img src="images/SadRobot.jpg" alt="Sad Robot" title="Sad Robot" className={styles['image-div']} />
        </div>
      </div>
      <div className={styles['right-container']}>
        <div className={styles['contact-information-wrapper']}>
          <div className={styles['contact-information-title']}>
            <p>{errorType === ErrorType.ReactError ? 'Contact Information' : t('ContactInformation')}</p>
          </div>
          <div className={styles['contact-information-div-1']}>
            <h5>{errorType === ErrorType.ReactError ? 'PHConnect Worldwide User Help' : t('PHConnectWorldwideUserHelp')}</h5>
            <p>{errorType === ErrorType.ReactError ? 'Contact your PHConnect Administrator' : t('ContactYourPHConnectAdministrator')}</p>
          </div>
          <div className={styles['contact-information-div-2']}>
            <h5>{errorType === ErrorType.ReactError ? 'Employee Helpdesk' : t('EmployeeHelpdesk')}</h5>
            <p className={styles['contact-number']}>(1) 216-896-4357</p>
            <p className={styles['contact-email']}>{errorType === ErrorType.ReactError ? 'Data.Center.Support@parker.com' : t('SupportEmail')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
